import { UnitLookupOption } from 'types';
import fetchWithRetry from './fetch-retry';

const BASE_URL = '/api/unit-statuses';

/* active labels only, already sorted by the backend — feeds dropdowns */
export const getUnitStatusOptions = async (): Promise<string[]> =>
  await fetchWithRetry<string[]>(`${BASE_URL}/options`, { method: 'GET' }, []);

/* full rows incl. inactive — feeds the admin grid */
export const getUnitStatusList = async (): Promise<UnitLookupOption[]> =>
  await fetchWithRetry<UnitLookupOption[]>(BASE_URL, { method: 'GET' }, []);

export const saveUnitStatus = async (option: Partial<UnitLookupOption>): Promise<UnitLookupOption> => {
  const response = await fetch(BASE_URL, {
    method: 'POST',
    body: JSON.stringify(option),
    headers: new Headers({
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json'
    })
  });
  return response.json();
};

export const updateUnitStatus = async (option: UnitLookupOption): Promise<UnitLookupOption | undefined> =>
  await fetchWithRetry<UnitLookupOption | undefined>(
    `${BASE_URL}/${option.id}`,
    { method: 'PUT', body: JSON.stringify(option), headers: { 'Content-Type': 'application/json' } },
    undefined
  );

/* soft delete — backend sets active=false */
export const deleteUnitStatus = async (id: number): Promise<void> =>
  await fetchWithRetry<void>(`${BASE_URL}/${id}`, { method: 'DELETE' }, undefined);
